document.addEventListener("DOMContentLoaded", async function () {

  // 🔒 Apple Pay support check
  if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
    console.log("Apple Pay not supported");
    return;
  }

  const applepay = paypal.Applepay();

  const config = await applepay.config();

  if (!config.isEligible) {
    console.log("Apple Pay not eligible");
    return;
  }

  const container =
    document.getElementById("applepay-product") ||
    document.getElementById("applepay-cart");

  if (!container) return;

  container.innerHTML = `
    <apple-pay-button 
      id="apple-pay-btn"
      buttonstyle="black"
      type="buy"
      locale="en">
    </apple-pay-button>
  `;

  const baseAmount = Number(window.cartTotal || 100);
  const currency = window.cartCurrency || "USD";

  document.getElementById("apple-pay-btn").addEventListener("click", async () => {

    const paymentRequest = {
      countryCode: config.countryCode,
      currencyCode: currency,

      // 🔥 ASK APPLE PAY FOR DATA (CRITICAL)
      requiredShippingContactFields: ["postalAddress", "name", "email", "phone"],

      lineItems: [
        { label: "Subtotal", amount: baseAmount.toFixed(2) }
      ],

      total: {
        label: "Jewels of Toronto",
        amount: baseAmount.toFixed(2)
      },

      supportedNetworks: config.supportedNetworks,
      merchantCapabilities: config.merchantCapabilities
    };

    const session = new ApplePaySession(4, paymentRequest);

    // 🔥 TAX LOGIC
    session.onshippingcontactselected = async (event) => {
      const contact = event.shippingContact;

      let tax = 0;

      if (contact.countryCode === "CA") {
        tax = baseAmount * 0.13;
      }

      const finalTotal = (baseAmount + tax).toFixed(2);

      session.completeShippingContactSelection({
        newTotal: {
          label: "Jewels of Toronto",
          amount: finalTotal
        },
        newLineItems: [
          { label: "Subtotal", amount: baseAmount.toFixed(2) },
          { label: "Tax", amount: tax.toFixed(2) }
        ]
      });

      window.finalApplePayTotal = finalTotal;
    };

    // 🔐 Merchant validation
    session.onvalidatemerchant = async (event) => {
      const merchantSession = await applepay.validateMerchant({
        validationUrl: event.validationURL,
        displayName: "Jewels of Toronto"
      });
      session.completeMerchantValidation(merchantSession);
    };

    // 💳 PAYMENT FLOW
    session.onpaymentauthorized = async (event) => {
      try {

        const amountToCharge =
          window.finalApplePayTotal || baseAmount.toFixed(2);

        const shipping = event.payment.shippingContact || {};
        const billing = event.payment.billingContact || {};

        // 1. CREATE PAYPAL ORDER
        const orderRes = await fetch("/api/orders", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amount: Number(amountToCharge),
            currency: currency
          })
        });

        const order = await orderRes.json();

        // 2. CONFIRM
        await applepay.confirmOrder({
          orderId: order.id,
          token: event.payment.token,
          billingContact: billing
        });

        // 3. CAPTURE
        await fetch(`/api/orders/${order.id}/capture`, { method: "POST" });

        // 🔥 CREATE SHOPIFY ORDER WITH REAL DATA
        await fetch("/api/create-shopify-order", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: window.cartData.items,
            amount: Number(amountToCharge),
            currency: currency,

            customer: {
              first_name: shipping.givenName || billing.givenName,
              last_name: shipping.familyName || billing.familyName,
              email: shipping.emailAddress || billing.emailAddress
            },

            shipping: {
              first_name: shipping.givenName,
              last_name: shipping.familyName,
              address1: (shipping.addressLines || []).join(" "),
              city: shipping.locality,
              province: shipping.administrativeArea,
              country: shipping.country,
              zip: shipping.postalCode,
              phone: shipping.phoneNumber
            }
          })
        });

        session.completePayment(ApplePaySession.STATUS_SUCCESS);

        window.location.href = "/thank-you";

      } catch (err) {
        console.error("Payment failed:", err);
        session.completePayment(ApplePaySession.STATUS_FAILURE);
      }
    };

    session.begin();
  });

});